import PropTypes from 'prop-types';

function HelperDetailList(props) {
  return (
    <div className="HelperDetailList">
      {props.children}
    </div>
  );
}

HelperDetailList.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HelperDetailList;
